import Swatch from 'components/DashBoard/ContentBin/Bins/Materials/Displays/Swatch'
import React from 'react'
import { useHistory } from 'react-router-dom'
import { useQuery } from '@apollo/client'

import { swatchType } from '../../materialTypes'
import { Q_MATERIAL_SWATCHES } from 'graphql/query'
import styles from './../../materials.module.scss'
import { Typography } from '@material-ui/core'
import Loading from 'components/Global/Loading'

const Swatches = () => {
  let history = useHistory()
  const [loading, setLoading] = React.useState<boolean>(true)

  const { refetch } = useQuery(Q_MATERIAL_SWATCHES, {
    variables: {
      id: parseInt(history.location.pathname.split('/')[3]),
    },
  })

  const [swatches, setSwatches] = React.useState<swatchType[]>()
  const [catalogue, setCatalogue] = React.useState<string>('')

  React.useEffect(() => {
    refetch() &&
      refetch().then(res => {
        setSwatches(res.data.rMaterialCatalogue[0].swatches)
        setCatalogue(res.data.rMaterialCatalogue[0].name)
        setLoading(false)
      })
  }, [refetch])

  return loading ? (
    <Loading />
  ) : (
    <div className={styles.stsColumn}>
      <Typography variant="h5" className={styles.catTypo}>
        {catalogue}
      </Typography>
      {swatches !== undefined &&
        swatches.map(s => {
          return (
            <Swatch
              {...s}
              key={s.id}
              active={false}
              onClickFn={() => console.log('clicked')}
            />
          )
        })}
    </div>
  )
}

export default Swatches
